import { BsFiletypeHtml, BsFiletypeCss, BsBootstrap } from "react-icons/bs";
import { FaNodeJs } from "react-icons/fa";
import { TbBrandNextjs } from "react-icons/tb";
import {
  SiJavascript,
  SiMui,
  SiReact,
  SiTailwindcss,
  SiAdobephotoshop,
  SiMongodb,
  SiMysql,
  SiGithub,
  SiWordpress,
  SiFirebase,
  SiExpress,
} from "react-icons/si";
export const TechstackList = [
  {
    _id: 1,
    name: "HTML",
    icon: BsFiletypeHtml,
  },
  {
    _id: 2,
    name: "CSS",
    icon: BsFiletypeCss,
  },
  {
    _id: 3,
    name: "Bootstrap",
    icon: BsBootstrap,
  },
  {
    _id: 4,
    name: "Javascript",
    icon: SiJavascript,
  },
  {
    _id: 5,
    name: "React JS",
    icon: SiReact,
  },
  {
    _id: 6,
    name: "Nextjs",
    icon: TbBrandNextjs,
  },
  {
    _id: 7,
    name: "React MUI",
    icon: SiMui,
  },
  {
    _id: 8,
    name: "Tailwind ",
    icon: SiTailwindcss,
  },
  {
    _id: 9,
    name: "Photoshop ",
    icon: SiAdobephotoshop,
  },
  {
    _id: 10,
    name: "React Native ",
    icon: SiReact,
  },
  {
    _id: 11,
    name: "Node JS ",
    icon: FaNodeJs,
  },
  {
    _id: 12,
    name: "Express JS ",
    icon: SiExpress,
  },
  {
    _id: 13,
    name: "Wordpress ",
    icon: SiWordpress,
  },
  {
    _id: 14,
    name: "Mongodb ",
    icon: SiMongodb,
  },
  {
    _id: 15,
    name: "My SQL ",
    icon: SiMysql,
  },
  {
    _id: 16,
    name: "Firebase ",
    icon: SiFirebase,
  },
  {
    _id: 17,
    name: "Git / Github ",
    icon: SiGithub,
  }
];
